import type { ReceiptTemplate } from '../schema';

export const chipotleTemplate: ReceiptTemplate = {
  id: 'chipotle',
  name: 'Chipotle Receipt',
  brand: 'CHIPOTLE',
  description: 'Chipotle Mexican Grill receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'chipotle-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/chipotle.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'MEXICAN GRILL',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chipotle-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'ORDER:', value: '#847' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 12:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chipotle-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'BURRITO BOWL', quantity: '1', price: '11.75', sku: '' },
          { id: '2', name: '  CHICKEN', quantity: '1', price: '0.00', sku: '' },
          { id: '3', name: '  WHITE RICE', quantity: '1', price: '0.00', sku: '' },
          { id: '4', name: '  BLACK BEANS', quantity: '1', price: '0.00', sku: '' },
          { id: '5', name: '  GUACAMOLE', quantity: '1', price: '3.00', sku: '' },
          { id: '6', name: 'CHIPS & GUAC', quantity: '1', price: '5.95', sku: '' },
          { id: '7', name: 'FOUNTAIN DRINK LG', quantity: '1', price: '3.10', sku: '' },
        ],
        showQuantity: false,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chipotle-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '23.80', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.96', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '25.76', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chipotle-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chipotle-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'CULTIVATE A BETTER WORLD\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

